// extracted by mini-css-extract-plugin
export default {"textBodyConfirmModal":"ClientVariable_textBodyConfirmModal__FyU+x","textVariableBodyConfirmModal":"ClientVariable_textVariableBodyConfirmModal__qquxV"};